import React from 'react'
import { MdBookmarkBorder, MdBookmark } from 'react-icons/md'
import PropTypes from 'prop-types'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './cardContent.module.scss'

const CardContent = ({ item, onPressMarker }) => {
  return (
    <div className={styles.contentItem}>
      <Text size="lg" color="gray" variation="dark" lineHeight="30px" extraBold>
        {item.title}
      </Text>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        margin="16px 0px"
      >
        <Flex alignItems="center">
          <Text
            size="xs"
            color="gray"
            variation="light"
            lineHeight="20px"
            font="custom"
          >
            Atualizado {item.updateFormatted}
          </Text>
        </Flex>
        {item.isFavorite ? (
          <MdBookmark color="#4d4d4d" size={25} />
        ) : (
          <MdBookmarkBorder onClick={onPressMarker} color="#4d4d4d" size={25} />
        )}
      </Flex>

      <div
        className={styles.content}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: item.contentBody }}
      />

      <Flex
        alignItems="center"
        justifyContent="center"
        margin="30px 0px 0px 0px"
      >
        <button
          type="button"
          onClick={onPressMarker}
          className={styles.saveContent}
        >
          <Text
            size="xs"
            color="gray"
            variation="dark"
            font="custom"
            lineHeight="20px"
            bold
            margin="0px 5px 0px 0px"
          >
            Salvar conteúdo
          </Text>
          {item.isFavorite ? (
            <MdBookmark color="#4d4d4d" size={15} />
          ) : (
            <MdBookmarkBorder color="#4d4d4d" size={15} />
          )}
        </button>
      </Flex>
    </div>
  )
}

CardContent.propTypes = {
  onPressMarker: PropTypes.func.isRequired,
  item: PropTypes.shape({
    title: PropTypes.string,
    isFavorite: PropTypes.bool,
    isFeatured: PropTypes.bool,
    contentBody: PropTypes.string,
    updateFormatted: PropTypes.string
  }).isRequired
}

export default CardContent
